var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38542 42C4.10208 42 3.00347 41.5431 2.08958 40.6292C1.17569 39.7153 0.71875 38.6167 0.71875 37.3333V4.66667C0.71875 3.38333 1.17569 2.28472 2.08958 1.37083C3.00347 0.456944 4.10208 0 5.38542 0H42.7188C44.0021 0 45.1007 0.456944 46.0146 1.37083C46.9285 2.28472 47.3854 3.38333 47.3854 4.66667V37.3333C47.3854 38.6167 46.9285 39.7153 46.0146 40.6292C45.1007 41.5431 44.0021 42 42.7188 42H5.38542ZM7.71875 32.6667H19.3854V28H7.71875V32.6667ZM30.0021 28L41.5521 16.45L38.2271 13.125L30.0021 21.4083L26.6771 18.0833L23.4104 21.4083L30.0021 28ZM7.71875 23.3333H19.3854V18.6667H7.71875V23.3333ZM7.71875 14H19.3854V9.33333H7.71875V14Z",
    fill: "#004EA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactCheck);
export default __webpack_public_path__ + "static/media/fact_check.5661e29f7853d811d54d5e58953078da.svg";
export { ForwardRef as ReactComponent };